import useMetadata from '../data/metadata/useMetadata';

export default function useFeatures() {
  const { features: featureMeta } = useMetadata();

  const features: Record<string, boolean> = featureMeta.isError
    ? {}
    : (featureMeta.data?.reduce(
        (acc, f) => {
          acc[f.key.toLocaleLowerCase()] = f.value === 'true';
          return acc;
        },
        {} as Record<string, boolean>
      ) ?? {});

  const canUseFeature = (feature: string) => {
    if (featureMeta.isLoading) return false;

    const feat = feature.toLocaleLowerCase();

    console.log('Checking feature', feat, 'Value:', features[feat]);

    if (!Object.keys(features).includes(feat)) {
      return false;
    }

    if (!features[feat]) {
      return false;
    }

    return features[feat];
  };

  return {
    isLoading: featureMeta.isLoading,
    features,
    canUseFeature,
  };
}
